__turbopack_context__.v({
  "actions": "i8hIUW_actions",
  "article": "i8hIUW_article",
  "page": "i8hIUW_page",
});
